var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.isLoginPage
        ? _c(
            "nav",
            { staticClass: "navbar navbar-expand-lg navbar-dark bg-success" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "container-fluid d-flex align-items-center justify-content-between",
                },
                [
                  _c(
                    "a",
                    { staticClass: "navbar-brand", attrs: { href: "#" } },
                    [_vm._v("Modul Rekam Medis")]
                  ),
                  _vm._v(" "),
                  _c("UserDropDown"),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoginPage ? _c("NavigationMenu") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [_c("router-view")], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }